import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchMyPromos, fetchPromos, createPromo, updatePromo, deletePromo } from '../actions/promos.actions';
import ListState from '../states/list.state';

const initialState: ListState = {
  loading: false,
  data: [],
  error: null,
  meta: null,
};

const promosSlice = createSlice({
  name: 'promos',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyPromos.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyPromos.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(fetchMyPromos.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      })

      .addCase(fetchPromos.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPromos.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(fetchPromos.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      })

      .addCase(createPromo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPromo.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = [action.payload, ...state.data];
      })
      .addCase(createPromo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      })

      .addCase(updatePromo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePromo.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = [...state.data].map((promo: any) => promo?.id === action.payload?.id ? action.payload : promo);
      })
      .addCase(updatePromo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      })

      .addCase(deletePromo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePromo.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = [...state.data].filter((promo: any) => promo?.id !== action.payload);
      })
      .addCase(deletePromo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      })

  },
});

export default promosSlice.reducer;
